<template>
  <div v-if="getPermission.ibslist.view || getPermission.ibslistob.view || getPermission.fsiac2.view">

      <md-tabs md-sync-route class="ibslist-tabs">
        <md-tab id="tab-inbound" md-label="Inbound" to="/ibslist/ibsinbound" v-if="getPermission.ibslist.view"></md-tab>
        <md-tab id="tab-outbound" md-label="Outbound" to="/ibslist/ibsoutbound" v-if="getPermission.ibslistob.view"></md-tab>
      </md-tabs>
      <router-view/>

  </div>

</template>

<style lang="scss">


.ibslist-tabs {
  .md-tabs-navigation {
    .md-theme-default {
      height: 30px;
    }
  }
}
</style>


<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters([
      'getPermission',
      'getMasterDataName',
    ]),
  },
};

</script>